import { useMutation } from 'data-fetching-client';
import { useCallback } from 'react';
import { CLONE_EMAIL } from '../queries/cloneEmail';
function generatePayload(options) {
  const payload = {
    name: options.name,
    variantOnly: options.variantOnly,
    convertToDd: options.convertToDd,
    cloneWithSmartContent: options.cloneWithSmartContent,
    cloneWithCustomPlaintext: options.cloneWithCustomPlaintext,
    retainPermissionsAfterClone: options.retainPermissionsAfterClone,
    folderId: options.folderId || null
  };
  if (options.state) {
    payload.state = options.state;
  }
  if (options.subcategory) {
    payload.subCategory = options.subcategory;
  }
  if (options.cloneWithNewBusinessUnitId !== undefined && options.cloneWithNewBusinessUnitId !== null) {
    payload.cloneWithNewBusinessUnitId = options.cloneWithNewBusinessUnitId;
  }
  if (options.customProperties && options.customProperties.length > 0) {
    payload.customProperties = {
      propertyValues: options.customProperties
    };
  }
  return payload;
}
export default function useCloneEmail(props) {
  const [_cloneEmail] = useMutation(CLONE_EMAIL, {
    onCompleted(data) {
      props.onCompleted(data.cloneEmail);
    },
    onError: (err, context) => {
      var _context$variables;
      props.onError(err, (context === null || context === void 0 || (_context$variables = context.variables) === null || _context$variables === void 0 ? void 0 : _context$variables.payload) || null);
    }
  });
  return useCallback(({
    id,
    options
  }) => {
    const payload = generatePayload(options);
    return _cloneEmail({
      variables: {
        payload,
        id
      }
    });
  }, [_cloneEmail]);
}